import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { docIdSide } from "../../modules/kyc/shared/config";
import ResponsiveLayout from "./ResponsiveLayout";
import ResponsiveDialog from "./ResponsiveDialog";
import { assetIds, ThemedAsset } from "nemuru-components";
import Text from "./Text";

const DOC_ID_DATA = (isMobile) => ({
  [docIdSide.DNI_ES_FRONT]: {
    iconAssetName: assetIds.ICON_ID_FRONT,
    title: "DNI_ES_FRONT",
    instructionsText: isMobile
      ? "PICTURE_INSTRUCTIONS_MOBILE"
      : "PICTURE_INSTRUCTIONS",
  },
  [docIdSide.DNI_ES_BACK]: {
    iconAssetName: assetIds.ICON_ID_BACK,
    title: "DNI_ES_BACK",
    instructionsText: isMobile
      ? "PICTURE_INSTRUCTIONS_MOBILE"
      : "PICTURE_INSTRUCTIONS",
  },
  [docIdSide.NIE_UE_FRONT]: {
    iconAssetName: assetIds.ICON_ID_FRONT,
    title: "NIE_UE_FRONT",
    instructionsText: isMobile
      ? "PICTURE_INSTRUCTIONS_MOBILE"
      : "PICTURE_INSTRUCTIONS",
  },
  [docIdSide.NIE_UE_BACK]: {
    iconAssetName: assetIds.ICON_ID_BACK,
    title: "NIE_UE_BACK",
    instructionsText: isMobile
      ? "PICTURE_INSTRUCTIONS_MOBILE"
      : "PICTURE_INSTRUCTIONS",
  },
  [docIdSide.NIE_NON_UE_FRONT]: {
    iconAssetName: assetIds.ICON_ID_FRONT,
    title: "NIE_NON_UE_FRONT",
    instructionsText: isMobile
      ? "PICTURE_INSTRUCTIONS_MOBILE"
      : "PICTURE_INSTRUCTIONS",
  },
  [docIdSide.NIE_NON_UE_BACK]: {
    iconAssetName: assetIds.ICON_ID_BACK,
    title: "NIE_NON_UE_BACK",
    instructionsText: isMobile
      ? "PICTURE_INSTRUCTIONS_MOBILE"
      : "PICTURE_INSTRUCTIONS",
  },
  [docIdSide.PASSPORT_FRONT]: {
    iconAssetName: assetIds.ICON_PASSPORT,
    title: "PASSPORT_FRONT",
    instructionsText: isMobile
      ? "PASSPORT_PICTURE_INSTRUCTIONS_MOBILE"
      : "PASSPORT_PICTURE_INSTRUCTIONS",
  },
});

export default function UploadDocIdPictureDialog({
  currentDocIdSide,
  onUploadImage,
  onClose,
  open,
}) {
  const { breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  const { register } = useForm();
  const { palette } = useTheme();
  const [uploadingImgState, setUploadingImgState] = useState(false);
  const uploadingImage = (e) => {
    setUploadingImgState(true);
    onUploadImage(e);
  };
  return (
    <ResponsiveDialog
      PaperProps={{
        "aria-label": "Upload document id picture dialog",
      }}
      open={open}
      onClose={onClose}
      displayCondition={true}
      fullScreenCondition={true}
    >
      <Container style={{ padding: "1rem 1rem", height: "100%" }}>
        {uploadingImgState && (
          <Box
            display="flex"
            flex="auto"
            justifyContent="center"
            alignItems="center"
            className="appear-anim"
            style={{
              position: "absolute",
              width: "calc(100% - 32px)",
              height: "calc(100% - 32px)",
              zIndex: 1,
              background: "#fff",
            }}
          >
            <CircularProgress
              size={90}
              style={{ color: palette.secondary.main }}
              thickness={1.5}
            />
          </Box>
        )}
        <ResponsiveLayout>
          <>
            <Box style={{ height: "15vh" }} />
            <Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography
                  style={{ color: palette.text.title }}
                  align="center"
                  variant={isScreenXs ? "body1" : "h6"}
                >
                  <strong>
                    <Text tId={DOC_ID_DATA[currentDocIdSide]?.title} />
                  </strong>
                </Typography>
              </Box>
              <ThemedAsset
                id={DOC_ID_DATA(isScreenXs)[currentDocIdSide]?.iconAssetName}
                width={150}
                height={150}
                style={{ textAlign: "center", color: palette.secondary.main }}
              />
              <Box m={3}>
                <Typography align="center" variant="body2">
                  <Text
                    tId={
                      DOC_ID_DATA(isScreenXs)[currentDocIdSide]
                        ?.instructionsText
                    }
                  />
                </Typography>
              </Box>
            </Box>
            <Box mt={4}>
              <input
                ref={register}
                type="file"
                name={currentDocIdSide}
                id={`file-input-${currentDocIdSide}`}
                hidden
                onChange={(e) => uploadingImage(e)}
              />
              <label
                htmlFor={`file-input-${currentDocIdSide}`}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    document
                      .getElementById(`file-input-${currentDocIdSide}`)
                      .click();
                  }
                }}
              >
                <Button
                  className="progression"
                  style={{ width: "100%", height: 48 }}
                  variant="contained"
                  color="primary"
                  component="span"
                  aria-label="Take picture"
                >
                  <Text tId={isScreenXs ? "TAKE_PICTURE" : "UPLOAD_PICTURE"} />
                </Button>
              </label>
            </Box>
          </>
        </ResponsiveLayout>
      </Container>
    </ResponsiveDialog>
  );
}
